export default __webpack_public_path__ + "static/media/SYBLogo.6f8044d9.svg";